import React, {Component, Fragment} from 'react'
import {Calendar, Select, Col, Row, message,} from 'antd';
import {reqTrainView, reqTrainInfo} from '../../api'
import {YgIcon} from '../../components/yg-icon'
import moment from 'moment';
import './order-view.less'
import "./main-page.less";
import boxImg from "../../assets/images/box.png"
import {convertToOptions} from '../../components/options'
import {TRAIN_PORT_DELIVERY_TYPE} from "../../utills/constants";
const dayFormat = 'YYYY-MM-DD';
const monthFormat = 'YYYY-MM';
export default class OrderView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            number: {monthPlanSum: 0, orderSum: 0},
            list: null,
            now: moment(new Date()).format(dayFormat),
            train: {},
            deliveryType: 'Z',
        };
        this.textInput = React.createRef();
    }

    componentDidMount() {
        const {now, deliveryType} = this.state;
        const leaveCountryDt = now.substr(0, 7) + '-01';
        this.handleSearch(leaveCountryDt);
        this.getTrainInfo(deliveryType);
        this.setState({leaveCountryDt});
    }

    handleSearch = (leaveCountryDt) => {
        const values = {};
        values.leaveCountryDt = leaveCountryDt ? leaveCountryDt : this.state.leaveCountryDt;
        values.deliveryType = this.state.deliveryType;
        this.getProducts(values);
    };
    handleDeliveryType = (deliveryType) => {
        const values = {};
        values.leaveCountryDt = this.state.leaveCountryDt;
        values.deliveryType = deliveryType;
        this.getProducts(values);
        //企业订舱天数
        this.getTrainInfo(deliveryType);
        this.setState({deliveryType});
    };
    getProducts = async (values = {}) => {
        let result = await reqTrainView(values);
        if (result.code == 200) {
            if (result.data) {
                const len = result.data.number ? result.data.number.length : 0;
                this.setState({
                    number: len > 0 ? result.data.number[0] : {monthPlanSum: 0, orderSum: 0},
                    list: result.data,
                }, function () {
                    if (this.textInput.current != null && this.textInput.current.state != null) {
                        this.textInput.current.state.value = this.state.number.monthPlanSum;
                    }
                });
            }
        } else {
            message.error(result.message)
        }
    };
    dateCellRender = (value) => {
        const listData = this.state.list[value.format(dayFormat)];
        if (Array.isArray(listData)) {
            return (
                <div className="events">
                    {listData.length > 0 ?
                        <div className="item">
                            <img src={boxImg} width="28px"></img>
                            <span className="box-number">
                                <span className="sign"> x </span>
                                <span className="num">{listData.length}</span></span>
                        </div> : null}
                </div>
            );
        }

    };
    handlePanelChange = (date, mode) => {
        this.handleSearch(date.format(monthFormat + '-01'));
        this.setState({leaveCountryDt: date.format(monthFormat + '-01')});
    };

    //企业订舱天数
    getTrainInfo = async (deliveryType) => {
        let result = await reqTrainInfo({deliveryType});
        if (result.code === 200) {
            this.setState({train: result.data})
        } else {
            message.error(result.message)
        }
    };

    render() {
        const {leaveCountryDt, number, list, train, deliveryType} = this.state;
        return <div className="echarts-information">
            <div className="plan-content">
                <div className="picture"></div>
                <div className="left">
                    <p className="head">
                        <span className="number">{leaveCountryDt ? moment(leaveCountryDt).get('month') + 1 : ''}</span>
                        月 {TRAIN_PORT_DELIVERY_TYPE[deliveryType]}计划
                    </p>
                    <p className='item'>
                        <span className="label"><YgIcon type="icon-zong" style={{fontSize: "25px"}}/>&nbsp;
                            <span>总计划：</span></span>
                        <span className="number">{number.monthPlanSum ? number.monthPlanSum : 0}</span>
                    </p>
                    <p className="item">
                        <span><YgIcon type="icon-shiyong" style={{fontSize: "25px"}}/>&nbsp;已使用：</span>
                        <span className="number">{number.orderSum ? number.orderSum : 0}</span>
                    </p>
                    <p className='item'>
                        <span><YgIcon type="icon-sheng" style={{fontSize: "25px"}}/>&nbsp;剩余计划：</span>
                        <span className="number"> {Number(number.monthPlanSum) - Number(number.orderSum)}</span>
                    </p>
                </div>
                <div className="calender">
                    {list != null ?
                        <Calendar dateCellRender={this.dateCellRender} onPanelChange={this.handlePanelChange}
                                  headerRender={({value, type, onChange, onTypeChange}) => {
                                      let lastDay;
                                      //提前天数
                                      const preDay = moment().add('days', train.monthDay - 1).endOf('day');
                                      //当月最后一天
                                      const curMonthLastDay = moment().endOf('month');
                                      //下月最后一天
                                      const nextMonthLastDay = moment().add('month', 1).endOf('month');
                                      if (preDay < curMonthLastDay) { //展示当月
                                          lastDay = curMonthLastDay;
                                      } else { //展示下月
                                          lastDay = nextMonthLastDay;
                                      }
                                      const lastDayMonth = lastDay.get('month');
                                      const lastDayYear = lastDay.get('year');
                                      const start = 0;
                                      const end = 12;
                                      const monthOptions = [];

                                      const current = value.clone();
                                      const localeData = value.localeData();
                                      const months = [];
                                      for (let i = 0; i < 12; i++) {
                                          current.month(i);
                                          months.push(localeData.monthsShort(current));
                                      }
                                      //下个月||以后年的月
                                      for (let index = start; index < end; index++) {
                                          monthOptions.push(
                                              <Select.Option className="month-item" key={`${index}`}
                                                             disabled={(value.year() === lastDayYear && index > lastDayMonth)
                                                             || value.year() > lastDayYear
                                                             }>
                                                  {months[index]}
                                              </Select.Option>,
                                          );
                                      }
                                      const month = value.month();

                                      const year = value.year();
                                      const options = [];
                                      for (let i = year - 10; i < year + 10; i += 1) {
                                          options.push(
                                              <Select.Option key={i} value={i} className="year-item">
                                                  {i}
                                              </Select.Option>,
                                          );
                                      }
                                      return (
                                          <div className="date">
                                              <Select
                                                  dropdownMatchSelectWidth={false}
                                                  className="my-year-select"
                                                  onChange={newYear => {
                                                      const now = value.clone().year(newYear);
                                                      onChange(now);
                                                  }}
                                                  value={String(year)}
                                              >
                                                  {options}
                                              </Select>
                                              <Select
                                                  dropdownMatchSelectWidth={false}
                                                  value={String(month)}
                                                  onChange={selectedMonth => {
                                                      const newValue = value.clone();
                                                      newValue.month(parseInt(selectedMonth, 10));
                                                      onChange(newValue);
                                                  }}
                                              >
                                                  {monthOptions}
                                              </Select>
                                              <Select getPopupContainer={triggerNode => triggerNode.parentNode}
                                                      onChange={this.handleDeliveryType}
                                                      defaultValue={deliveryType}>
                                                  {convertToOptions(TRAIN_PORT_DELIVERY_TYPE)}
                                              </Select>
                                          </div>
                                      );
                                  }}
                        /> : null}
                </div>
            </div>
        </div>
    }
}